import React, { useEffect, useState } from 'react';

import SignUpActivationView from 'views/SignUpActivation';
import RegisterService from 'api/Register';
import { handlePromise } from 'utils';

const SignUpActivation = ( { match, history } ) => {
  const [error, setError] = useState( null );
  const [dataLoading, setDataLoading] = useState( true );

  useEffect( () => {
    const getData = async () => {
      setDataLoading( true );
      const [errors, response, responseData] = await handlePromise(
        RegisterService.verifyAccountToken( match.params.token ),
      );
      setDataLoading( false );

      if ( !response.ok ) return setError( errors );
      if ( responseData.tokenRecoverPass ) return history.push( `/auth/recover-password/${responseData.tokenRecoverPass}` );
    };
    getData();
  }, [match.params.token] ); //eslint-disable-line

  return (
    <SignUpActivationView
      error={error}
      isLoading={dataLoading}
    />
  );
};

export default SignUpActivation;
